import { FC } from 'react'

import AlertPurchseProvider from './AlertPurchaseProvider'
import FollowUpProvider from './FollowUpProvider'
import FollowUpReabProvider from './FollowUpReabProvider'
import PurchaseProvider from './PurchaseProvider'

const AlertsProvider: FC = ({ children }) => {
  return (
    <FollowUpProvider>
      <FollowUpReabProvider>
        <AlertPurchseProvider>
          <PurchaseProvider>{children}</PurchaseProvider>
        </AlertPurchseProvider>
      </FollowUpReabProvider>
    </FollowUpProvider>
  )
}

export default AlertsProvider
